/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Invitation_1Inputs */

const en_flow_invitation_1 = /** @type {(inputs: Flow_Invitation_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales invites the buyers of a market week from Guestlist.`)
};

/**
* | output |
* | --- |
* | "Sales invites the buyers of a market week from Guestlist." |
*
* @param {Flow_Invitation_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_invitation_1 = /** @type {((inputs?: Flow_Invitation_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Invitation_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_invitation_1(inputs)
});